import { SxProps, TableRow, TableCell, TextField, Tooltip, Typography, IconButton } from '@mui/material';
import React from 'react';
import { Competition } from 'shared/types/quotes';
import { defaultCompetition } from 'shared/constants/quotes';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';

const fieldStyles: SxProps = {
  backgroundColor: '#FFFFFF',
};

const cellStyles: SxProps = {
  padding: {
    xs: '5px',
    sm: '6px 16px',
  },
};
interface CompetitionInputRowProps {
  handleAddRow: (newRow: Competition) => void;
}
export const CompetitionInputRow = ({ handleAddRow }: CompetitionInputRowProps) => {
  const [newRow, setNewRow] = React.useState<Competition>(defaultCompetition);
  const disableAdd = !newRow.currentMarketPrice && !newRow.modelName && !newRow.modelNumber;
  return (
    <TableRow>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Specified Manufacturer'
          size='small'
          value={newRow.modelName}
          onChange={e => setNewRow(prev => ({ ...prev, modelName: e.target.value }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Model #'
          size='small'
          value={newRow.modelNumber}
          onChange={e => setNewRow(prev => ({ ...prev, modelNumber: e.target.value }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <TextField
          sx={fieldStyles}
          placeholder='Current Market $'
          size='small'
          type='number'
          value={newRow.currentMarketPrice}
          onChange={e => setNewRow(prev => ({ ...prev, currentMarketPrice: parseFloat(e.target.value || '0') }))}
        />
      </TableCell>
      <TableCell sx={cellStyles}>
        <Tooltip title={<Typography variant='body2'>Save</Typography>}>
          <span>
            <IconButton
              onClick={() => {
                handleAddRow(newRow);
                setNewRow(defaultCompetition);
              }}
              disabled={disableAdd}
            >
              <AddCircleOutlinedIcon color='success' />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};
